import React, {
  ComponentType,
  LazyExoticComponent,
  Suspense,
  lazy,
} from 'react'
import { Box, Grid, LinearProgress } from '@mui/material'
import { ROUTE_PATHS } from '~/constants/routes'

type LazyComponentType = LazyExoticComponent<ComponentType<any>>

const loader = (Component: LazyComponentType) => (props: any) =>
  (
    <Suspense
      fallback={
        <Grid item xs={12} display="flex" justifyContent="center">
          <Box sx={{ width: '100%', position: 'absolute', top: '2px' }}>
            <LinearProgress />
          </Box>
        </Grid>
      }
    >
      <Component {...props} />
    </Suspense>
  )

const Dashboard = loader(lazy(() => import('~/modules/dashboard')))
const Profile = loader(lazy(() => import('~/modules/profile')))

const UsersList = loader(lazy(() => import('~/modules/hr/users/list')))
const DepartmentsList = loader(
  lazy(() => import('~/modules/hr/departments/list'))
)
const RolesList = loader(lazy(() => import('~/modules/hr/roles/list')))
const CustomersList = loader(lazy(() => import('~/modules/customers/list')))
const RequestsList = loader(
  lazy(() => import('~/modules/customers/requests/list'))
)
const FreshRequestsList = loader(
  lazy(() => import('~/modules/customers/requests/fresh-requests/list'))
)
const AssignedRequests = loader(
  lazy(() => import('~/modules/customers/requests/assigned-requests/list'))
)
const MyRequests = loader(
  lazy(() => import('~/modules/customers/requests/my-requests/list'))
)
const ViewRequest = loader(
  lazy(() => import('~/modules/customers/requests/view'))
)
const Permissions = loader(lazy(() => import('~/modules/hr/permissions/list')))
const Holidays = loader(lazy(() => import('~/modules/hr/holidays/list')))
const Suppliers = loader(
  lazy(() => import('~/modules/accountants/suppliers/list'))
)
const RatingFactors = loader(lazy(() => import('~/modules/ratingFactors/list')))
const ChangePassword = loader(lazy(() => import('~/modules/changePassword')))
const Notifications = loader(lazy(() => import('~/modules/notifications')))
const SummaryRequest = loader(
  lazy(() => import('~/modules/customers/requests/summary-requests'))
)

const ReportsCount = loader(lazy(() => import('~/modules/reports/RequestsCount')))
const SalesReport = loader(lazy(() => import('~/modules/reports/SalesReport')))

export const routes: any[] = [
  {
    path: ROUTE_PATHS.DASHBOARD,
    component: <Dashboard />,
  },
  {
    path: ROUTE_PATHS.PROFILE,
    component: <Profile />,
  },
  {
    path: ROUTE_PATHS.NOTIFICATIONS,
    component: <Notifications />,
  },
  {
    path: ROUTE_PATHS.CHANGEPASSWORD,
    component: <ChangePassword />,
  },
  {
    path: ROUTE_PATHS.OPERATION_ASSIGNED_REQUESTS_LIST,
    component: <AssignedRequests />,
  },
  {
    path: ROUTE_PATHS.VIEW_REQUEST,
    component: <ViewRequest />,
  },
  {
    path: ROUTE_PATHS.REQUESTS_LIST,
    component: <RequestsList />,
  },
  {
    path: ROUTE_PATHS.AUDIT_FRESH_REQUESTS_LIST,
    component: <FreshRequestsList />,
  },
  {
    path: ROUTE_PATHS.AUDIT_ASSIGNED_REQUESTS_LIST,
    component: <AssignedRequests />,
  },
  {
    path: ROUTE_PATHS.VIEW_REQUEST,
    component: <ViewRequest />,
  },
  {
    path: ROUTE_PATHS.SALES_FRESH_REQUESTS_LIST,
    component: <FreshRequestsList />,
  },
  {
    path: ROUTE_PATHS.SALES_ASSIGNED_REQUESTS_LIST,
    component: <AssignedRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_MY_REQUESTS_LIST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_CALLED_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_WHATSAPP_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_PAID_PAYMENT_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_INTERSTED_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_BUSY_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_OUT_OF_SERVICE_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_NO_ANSWER_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_DONE_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.DONE_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_CANCELED_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_CONFIRMED_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_FOLLOWUP_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.VIEW_REQUEST,
    component: <ViewRequest />,
  },
  {
    path: ROUTE_PATHS.AUDIT_ASSIGNED_REQUESTS_LIST,
    component: <AssignedRequests />,
  },
  {
    path: ROUTE_PATHS.VIEW_REQUEST,
    component: <ViewRequest />,
  },
  { path: ROUTE_PATHS.SALES_REQUEST, component: <MyRequests /> },
  {
    path: ROUTE_PATHS.PERMISSIONS,
    component: <Permissions />,
  },
  {
    path: ROUTE_PATHS.HOLIDAAYS,
    component: <Holidays />,
  },
  { path: ROUTE_PATHS.CUSTOMERS_LIST, component: <CustomersList /> },
  {
    path: ROUTE_PATHS.USERS,
    component: <UsersList />,
  },
  {
    path: ROUTE_PATHS.DEPARTMENT,
    component: <DepartmentsList />,
  },
  {
    path: ROUTE_PATHS.ROLES,
    component: <RolesList />,
  },
  {
    path: ROUTE_PATHS.PERMISSIONS,
    component: <Permissions />,
  },
  {
    path: ROUTE_PATHS.HOLIDAAYS,
    component: <Holidays />,
  },
  {
    path: ROUTE_PATHS.SALES_REQUEST,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SUPPLIERS,
    component: <Suppliers />,
  },
  {
    path: ROUTE_PATHS.DONE_REQUESTS_LIST,
    component: <RequestsList />,
  },
  {
    path: ROUTE_PATHS.CONFIRMED_REQUESTS_LIST,
    component: <RequestsList />,
  },
  {
    path: ROUTE_PATHS.RATINGFACTOR,
    component: <RatingFactors />,
  },
  {
    path: ROUTE_PATHS.CALL_CENTER_ALLREQUEST,
    component: <RequestsList />,
  },
  {
    path: ROUTE_PATHS.ACCOUNTENT_FRESH,
    component: <FreshRequestsList />,
  },
  {
    path: ROUTE_PATHS.ACCOUNTENT_DONE,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.ACCOUNTENT_MYREQUESTS,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.ACCOUNTENT_ASSIGNED,
    component: <AssignedRequests />,
  },
  {
    path: ROUTE_PATHS.AUDIT_FRESH,
    component: <FreshRequestsList />,
  },
  {
    path: ROUTE_PATHS.AUDIT_MYREQUESTS,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.OPERATION_CONFIRMED_FRESH,
    component: <FreshRequestsList />,
  },
  {
    path: ROUTE_PATHS.OPERATION_CONFIRMED_ASSIGNED,
    component: <AssignedRequests />,
  },
  {
    path: ROUTE_PATHS.OPERATION_MYREQUSTS,
    component: <MyRequests />,
  },
  {
    path: ROUTE_PATHS.SALES_SUMMARY_REQUEST,
    component: <SummaryRequest />,
  },
  {
    path: ROUTE_PATHS.CALLCENTER_SUMMARY_REQUEST,
    component: <SummaryRequest />,
  },
  {
    path: ROUTE_PATHS.REPORTS_REQUESTS_COUNT,
    component: <ReportsCount />,
  },
  {
    path: ROUTE_PATHS.REPORTS_SALES,
    component: <SalesReport />,
  },
]
